import * as React from 'react'

function SvgBookIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 21H5a2 2 0 01-2-2v-8a2 2 0 012-2h22a2 2 0 012 2v5M9 15h8"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M26.559 27.43l-2.838-4.402-3.127 2.422-.016-10.977 9.172 6.031-3.74 1.288M16 5V1M23 6l1-4M9 6L8 2M16 25v4M9 24l-1 4"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  )
}

export default SvgBookIcon
